/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleAnalyticsAggregateReportRowData } from './GoogleAnalyticsAggregateReportRowData';
import {
    GoogleAnalyticsAggregateReportRowDataFromJSON,
    GoogleAnalyticsAggregateReportRowDataFromJSONTyped,
    GoogleAnalyticsAggregateReportRowDataToJSON,
    GoogleAnalyticsAggregateReportRowDataToJSONTyped,
} from './GoogleAnalyticsAggregateReportRowData';

/**
 * 
 * @export
 * @interface GoogleAnalyticsAggregateReportData
 */
export interface GoogleAnalyticsAggregateReportData {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAnalyticsAggregateReportData
     */
    available?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAggregateReportData
     */
    recipe?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAggregateReportData
     */
    completeness?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAggregateReportData
     */
    timeZone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAggregateReportData
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAggregateReportData
     */
    fetchedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAggregateReportData
     */
    publishedAt?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleAnalyticsAggregateReportData
     */
    nonAdditiveMetrics?: Array<string>;
    /**
     * 
     * @type {Array<GoogleAnalyticsAggregateReportRowData>}
     * @memberof GoogleAnalyticsAggregateReportData
     */
    rows?: Array<GoogleAnalyticsAggregateReportRowData>;
}

/**
 * Check if a given object implements the GoogleAnalyticsAggregateReportData interface.
 */
export function instanceOfGoogleAnalyticsAggregateReportData(value: object): value is GoogleAnalyticsAggregateReportData {
    return true;
}

export function GoogleAnalyticsAggregateReportDataFromJSON(json: any): GoogleAnalyticsAggregateReportData {
    return GoogleAnalyticsAggregateReportDataFromJSONTyped(json, false);
}

export function GoogleAnalyticsAggregateReportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAnalyticsAggregateReportData {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'] == null ? undefined : json['available'],
        'recipe': json['recipe'] == null ? undefined : json['recipe'],
        'completeness': json['completeness'] === undefined ? undefined : json['completeness'] === null ? null : json['completeness'],
        'timeZone': json['timeZone'] === undefined ? undefined : json['timeZone'] === null ? null : json['timeZone'],
        'currencyCode': json['currencyCode'] === undefined ? undefined : json['currencyCode'] === null ? null : json['currencyCode'],
        'fetchedAt': json['fetchedAt'] === undefined ? undefined : json['fetchedAt'] === null ? null : json['fetchedAt'],
        'publishedAt': json['publishedAt'] === undefined ? undefined : json['publishedAt'] === null ? null : json['publishedAt'],
        'nonAdditiveMetrics': json['nonAdditiveMetrics'] == null ? undefined : json['nonAdditiveMetrics'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(GoogleAnalyticsAggregateReportRowDataFromJSON)),
    };
}

export function GoogleAnalyticsAggregateReportDataToJSON(json: any): GoogleAnalyticsAggregateReportData {
    return GoogleAnalyticsAggregateReportDataToJSONTyped(json, false);
}

export function GoogleAnalyticsAggregateReportDataToJSONTyped(value?: GoogleAnalyticsAggregateReportData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available': value['available'],
        'recipe': value['recipe'],
        'completeness': value['completeness'],
        'timeZone': value['timeZone'],
        'currencyCode': value['currencyCode'],
        'fetchedAt': value['fetchedAt'],
        'publishedAt': value['publishedAt'],
        'nonAdditiveMetrics': value['nonAdditiveMetrics'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(GoogleAnalyticsAggregateReportRowDataToJSON)),
    };
}

